import { NgModule } from '@angular/core';
import { MaintenanceComponent } from './maintenance.component';
import { ToolMaintenanceRecurrencesComponent } from './containers/tool-maintenance-recurrences/tool-maintenance-recurrences.component';
import { ToolMaintenancePlansComponent } from './containers/tool-maintenance-plans/tool-maintenance-plans.component';
import { ToolMaintenanceActivitiesComponent } from './containers/tool-maintenance-activities/tool-maintenance-activities.component';
import { SharedModule } from '@app/shared/shared.module';
import { RecurrenceDetailsFormComponent } from './components/forms/recurrence-details-form/recurrence-details-form.component';
import * as fromMaintenance from './store/maintenance.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RecurrenceService } from './service/recurrence.service';
import { MaintenanceEffects } from './store/maintenance.effects';
import { MaintenanceNotificationsEffects } from './maintenance.notifications';
import { ActivityModalComponent } from './components/activity-modal/activity-modal.component';
import { ActivityFormComponent } from './components/forms/activity-form/activity-form.component';
import { ActivitiesService } from './service/activities.service';
import { ActivityOrderListComponent } from './components/activity-order-list/activity-order-list.component';
import { TaskFormComponent } from './components/forms/task-form/task-form.component';
import { ToolModule } from '@app/tool/tool.module';
import { TasksService } from './service/tasks.service';
import { ActivityDetailsComponent } from './containers/activity-details/activity-details.component';
import { TaskPhotoUploadModalComponent } from './components/task-photo-upload-modal/task-photo-upload-modal.component';
import { TaskInstructionsTreeModalComponent } from './components/task-instructions-tree-modal/task-instructions-tree-modal.component';
import { FileSelectorInputComponent } from './components/file-selector-input/file-selector-input.component';
import { PhotoSelectorInputComponent } from './components/photo-selector-input/photo-selector-input.component';
import { MaintenancePlanModalComponent } from './components/maintenance-plan-modal/maintenance-plan-modal.component';
import {
    MaintenancePlanDetailsFormComponent
} from './components/maintenance-plan-modal/forms/maintenance-plan-details-form/maintenance-plan-details-form.component';
import { MaintenancePlansService } from './service/maintenance-plans.service';
import {
    MaintenancePlanToolsFormComponent
} from './components/maintenance-plan-modal/forms/maintenance-plan-tools-form/maintenance-plan-tools-form.component';
import { MaintenancePlanToolsTableComponent } from './components/maintenance-plan-tools-table/maintenance-plan-tools-table.component';
import {
    MaintenancePlanActivitiesFormComponent
} from './components/maintenance-plan-modal/forms/maintenance-plan-activities-form/maintenance-plan-activities-form.component';
import { MaintenancePlanDetailsComponent } from './containers/maintenance-plan-details/maintenance-plan-details.component';
import { MaintenancePlansTableComponent } from './components/maintenance-plans-table/maintenance-plans-table.component';

@NgModule({
    declarations: [
        MaintenanceComponent,
        ToolMaintenanceRecurrencesComponent,
        ToolMaintenancePlansComponent,
        ToolMaintenanceActivitiesComponent,
        RecurrenceDetailsFormComponent,
        RecurrenceDetailsFormComponent,
        ActivityModalComponent,
        ActivityFormComponent,
        ActivityDetailsComponent,
        ActivityOrderListComponent,
        TaskFormComponent,
        TaskPhotoUploadModalComponent,
        TaskInstructionsTreeModalComponent,
        FileSelectorInputComponent,
        PhotoSelectorInputComponent,
        MaintenancePlanModalComponent,
        MaintenancePlansTableComponent,
        MaintenancePlanDetailsFormComponent,
        MaintenancePlanToolsFormComponent,
        MaintenancePlanToolsTableComponent,
        MaintenancePlanActivitiesFormComponent,
        MaintenancePlanDetailsComponent,
    ],
    imports: [
        SharedModule,
        ToolModule,
        StoreModule.forFeature(fromMaintenance.maintenanceFeatureKey, fromMaintenance.reducer),
        EffectsModule.forFeature([MaintenanceEffects, MaintenanceNotificationsEffects]),
    ],
    providers: [
        RecurrenceService,
        ActivitiesService,
        TasksService,
        MaintenancePlansService
    ],
    exports: [
        RecurrenceDetailsFormComponent
    ],
})
export class MaintenanceModule {
}
